<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
    <div class="modal-header">
        <div class="title">
            <h2 class="modal-title-prefix"><span>UKUPNO - ANALIZA</span></h2>
        </div>
    </div>
    <div class="modal-body">
        <yt-number-input-v3 name="txtT01VrednostUlazaPoNabavnojCeni" formControlName="T01VrednostUlazaPoNabavnojCeni"
            [Label]="'KARTICAMPARTIKLA.T01VREDNOSTULAZAPONABAVNOJCENI.SINGULAR'" [disabled]='true'>
        </yt-number-input-v3>
        <yt-number-input-v3 name="txtT02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni"
            formControlName="T02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni"
            [Label]="'KARTICAMPARTIKLA.T02VREDNOSTIZLAZAARTIKALAPOPROSECNOJNABAVNOJCENI.SINGULAR'" [disabled]='true'>
        </yt-number-input-v3>
        <yt-number-input-v3 name="txtT03VrednostIzlazaArtikalaPoProdajnojCeni"
            formControlName="T03VrednostIzlazaArtikalaPoProdajnojCeni"
            [Label]="'KARTICAMPARTIKLA.T03VREDNOSTIZLAZAARTIKALAPOPRODAJNOJCENI.SINGULAR'" [disabled]='true'>
        </yt-number-input-v3>
        <yt-number-input-v3 name="txtT04UkupnoPdvIzlazRobe" formControlName="T04UkupnoPdvIzlazRobe"
            [Label]="'KARTICAMPARTIKLA.T04UKUPNOPDVIZLAZROBE.SINGULAR'" [disabled]='true'>
        </yt-number-input-v3>
        <yt-number-input-v3 name="txtT05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv"
            formControlName="T05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv"
            [Label]="'KARTICAMPARTIKLA.T05VREDNOSTIZLAZAARTIKALAPOPRODAJNOJCENIBEZPDV.SINGULAR'" [disabled]='true'>
        </yt-number-input-v3>
        <yt-number-input-v3 name="T06RealizacijaDoUlozenogNovca" formControlName="T06RealizacijaDoUlozenogNovca"
            [Label]="'KARTICAMPARTIKLA.T06REALIZACIJADOULOZENOGNOVCA.SINGULAR'" [disabled]='true'>
        </yt-number-input-v3>
        <yt-number-input-v3 name="txtT07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda"
            formControlName="T07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda"
            [Label]="'KARTICAMPARTIKLA.T07UKUPNOOSTVARENARAZLIKAUCENINAKRAJUPERIODA.SINGULAR'" [disabled]='true'>
        </yt-number-input-v3>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="Close()"><span>Zatvori</span></button>
    </div>
</form>